import classNames from 'classnames';
import { IconGift } from '@/features/icons';
import { useVariantContextValues } from '../context/use-variant-context-values';
interface Props {
  className?: string;
}
function Gift({
  className
}: Props) {
  const {
    activeVariant
  } = useVariantContextValues('pdp');
  const giftName = activeVariant?.giftVariantNameFa;
  if (!giftName) return null;
  return <div className={classNames('flex w-full items-center gap-1.5 bg-primary-shade-100 px-4 py-1.5 text-primary-main lg:rounded lg:py-1', className)} data-sentry-component="Gift" data-sentry-source-file="gift.tsx">
            <div className='h-5 w-5'>
                <IconGift className='h-5 w-5' data-sentry-element="IconGift" data-sentry-source-file="gift.tsx" />
            </div>
            <span className='text-caption-12 lg:text-body-14'>
                با خرید این محصول، یک <span className='font-bold'>{giftName}</span> هدیه می‌گیرید!
            </span>
        </div>;
}
export default Gift;